import gsap from 'gsap';
import { html } from '@resn/gozer-core';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { autobind } from 'core-decorators';
import { lerp } from '@resn/gozer-math';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';

import './index.scss';

const template = ({ props, options }) => html`<div class="transitionOverlay__layers">
    <div class="js-layer  transitionOverlay__layer"></div>
    <div class="js-layer  transitionOverlay__layer"></div>
    <div class="js-layer  transitionOverlay__layer"></div>
</div>`;

@componentMixin(DomComponentMixin)
class TransitionOverlay extends Component {
    options = {
        template,
        numLayers: 3,
    };

    props = {
        active: false,
    };

    async onSetup() {
        this.layers = [...this.el.querySelectorAll('.js-layer')];

        this.layers.forEach((el, i) => {
            const alpha = lerp((i + 1) / this.layers.length, 0, 1);
            el.style.opacity = alpha;
        });
    }

    show({ dir = 0, dur = 1, fromY = false } = {}, onComplete) {
        const xFrom = fromY ? 0 : `${100 * dir}%`;
        const yFrom = fromY ? `${100 * dir}%` : 0;

        const stagger = 0.12;
        const duration = dur - this.layers.length * stagger;

        gsap.set(this.layers, { x: xFrom, y: yFrom });
        gsap.to(this.layers, {
            x: 0,
            duration,
            ease: 'power2.in',
            stagger,
            onComplete,
        });
    }

    hide({ dir = 0, dur = 2, fromY = false } = {}, onComplete) {
        const xTo = fromY ? 0 : `${100 * -dir}%`;
        const yTo = fromY ? `${100 * -dir}%` : 0;

        gsap.to(this.layers, {
            x: xTo,
            y: yTo,
            duration: dur,
            ease: 'expo.out',
            onComplete,
        });
    }

    setBgColor(color) {
        this.el.style.setProperty('--bg-color', color);
    }
}

export default TransitionOverlay;
